import { PrimaryActionButtonController } from './primary_action_button.controller';
import { PrimaryAction } from './primary_action_button.service';
import { DirectiveBase } from '../../components/angular-directive-base.directive';

export class PrimaryActionButton extends DirectiveBase {
  constructor() {
    super();
    this.templateUrl = 'app/angularJS/layout/primary_action_button/primary_action_button.html';
    this.bindToController = true;
    this.controller = 'primaryActionButtonController';
    this.controllerAs = 'vm';
    this.restrict = 'E';
    this.scope = false;
  }

}